export const wyrm_list_5 = [
  {
    type: 0,
    id: 400062,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'str_dbb', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400063,
    abilities: [ 
      { exclusive: '', effect: 'flr_str', value: 20, maxValue: 20},
      { exclusive: '', effect: 'wnd_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400064,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 15, maxValue: 20},
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400065,
    abilities: [ 
      { exclusive: '', effect: 'brk_pns', value: 30, maxValue: 30},
      { exclusive: '', effect: 'skl_prp', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400066,
    abilities: [ 
      { exclusive: '', effect: 'hfl_hl', value: 20, maxValue: 20},
      { exclusive: '', effect: 'crs_rs', value: 50, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400067,
    abilities: [ 
      { exclusive: '', effect: 'drg_tm', value: 20, maxValue: 20},
      { exclusive: '', effect: 'flm_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400068,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'lgh_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400070,
    abilities: [ 
      { exclusive: '', effect: 'h70_crt_rt', value: 10, maxValue: 15},
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400071,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 50, maxValue: 50},
      { exclusive: '', effect: 'frz_rs', value: 50, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400072,
    abilities: [ 
      { exclusive: '', effect: 'hmd_rs', value: 25, maxValue: 25},
      { exclusive: '', effect: 'md_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'wnd_rs', value: 5, maxValue: 15},
    ]
  }, {
    type: 0,
    id: 400052,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 13, maxValue: 20},
      { exclusive: '', effect: 'hfl_dfn', value: 20, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400075,
    abilities: [ 
      { exclusive: '', effect: 'lst_ofn', value: 50, maxValue: 60},
      { exclusive: '', effect: 'skl_dmg', value: 25, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400076,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 13, maxValue: 20},
      { exclusive: '', effect: 'flm_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 1,
    id: 400077,
    abilities: [ 
      { exclusive: '', effect: 'hfl_skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'bln_rs', value: 50, maxValue: 100}
    ]
  }, {
    type: 1,
    id: 400078,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 50, maxValue: 100},
      { exclusive: '', effect: 'shd_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400087,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400074,
    abilities: [ 
      { exclusive: '', effect: 'h70_hl', value: 15, maxValue: 20},
      { exclusive: '', effect: 'lst_dfn', value: 50, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400099,
    abilities: [ 
      { exclusive: '', effect: 'skl_hst', value: 8, maxValue: 15},
      { exclusive: '', effect: 'h70_str', value: 10, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400103,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 50, maxValue: 100},
      { exclusive: '', effect: 'hfl_str', value: 13, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400104,
    abilities: [ 
      { exclusive: '', effect: 'brk_pns', value: 30, maxValue: 30},
      { exclusive: '', effect: 'drg_tm', value: 15, maxValue: 20}
    ]
  }, {
    type: 2,
    id: 400107,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 13, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400110,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'h70_crt_rt', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400111,
    abilities: [ 
      { exclusive: '', effect: 'crs_rs', value: 60, maxValue: 100},
      { exclusive: 'light', effect: 'crs_rs', value: 40, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400121,
    abilities: [ 
      { exclusive: '', effect: 'hbr_rs', value: 25, maxValue: 25},
      { exclusive: '', effect: 'br_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'flm_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 1,
    id: 400091,
    abilities: [ 
      { exclusive: '', effect: 'h70_dfn', value: 13, maxValue: 20},
      { exclusive: '', effect: 'hl_dbb', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 1,
    id: 400115,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 20, maxValue: 25},
      { exclusive: 'water', effect: 'flr_dvs', value: 12, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400118,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 50, maxValue: 100}
    ]
  }, {
    type: 2,
    id: 400123,
    abilities: [ 
      { exclusive: '', effect: 'exp_1', value: 10, maxValue: 10}
    ]
  }, {
    type: 1,
    id: 400124,
    abilities: [ 
      { exclusive: '', effect: 'lgh_rs', value: 13, maxValue: 15},
      { exclusive: 'shadow', effect: 'prl_rs', value: 65, maxValue: 100}
    ]
  }, {
    type: 1,
    id: 400125,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'skl_hst', value: 6, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400128,
    abilities: [ 
      { exclusive: 'lance', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'shd_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400129,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 50, maxValue: 50},
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25}
    ]
  }, {
    type: 2,
    id: 400131,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 13, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400080,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 13, maxValue: 20},
      { exclusive: '', effect: 'slyr_str', value: 5, maxValue: 6}
    ]
  }, {
    type: 0,
    id: 400163,
    abilities: [ 
      { exclusive: 'axe', effect: 'crt_rt', value: 14, maxValue: 15},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400092,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 100, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400139,
    abilities: [ 
      { exclusive: 'flame', effect: 'afl_grd', value: 'Ⅲ', maxValue: '3'},
      { exclusive: '', effect: 'shl_prp', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 2,
    id: 400142,
    abilities: [ 
      { exclusive: '', effect: 'enr_prp', value: 'Ⅴ', maxValue: 'Ⅴ'}
    ]
  }, {
    type: 2,
    id: 400143,
    abilities: [ 
      { exclusive: '', effect: 'exp_2', value: 10, maxValue: 10}
    ]
  }, {
    type: 2,
    id: 400144,
    abilities: [ 
      { exclusive: '', effect: 'lst_ofn', value: 50, maxValue: 60}
    ]
  }, {
    type: 2,
    id: 400145,
    abilities: [ 
      { exclusive: '', effect: 'brk_pns', value: 30, maxValue: 30}
    ]
  }, {
    type: 2,
    id: 400146,
    abilities: [ 
      { exclusive: '', effect: 'brn_pns', value: 30, maxValue: 30}
    ]
  }, {
    type: 2,
    id: 400147,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 13, maxValue: 20}
    ]
  }, {
    type: 2,
    id: 400148,
    abilities: [ 
      { exclusive: 'flame', effect: 'skl_hst', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400167,
    abilities: [ 
      { exclusive: 'sword', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'drg_clw', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 0,
    id: 400150,
    abilities: [ 
      { exclusive: 'light', effect: 'afl_grd', value: 'Ⅲ', maxValue: '3'},
      { exclusive: '', effect: 'shd_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400154,
    abilities: [ 
      { exclusive: '', effect: 'lst_rcv', value: 'Ⅳ', maxValue: 'Ⅳ'},
      { exclusive: '', effect: 'shl_prp', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 2,
    id: 400157,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400172,
    abilities: [ 
      { exclusive: 'bow', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'stk_hst', value: 12, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400176,
    abilities: [ 
      { exclusive: '', effect: 'gg_acl', value: 30, maxValue: 35}
    ]
  }, {
    type: 0,
    id: 400108,
    abilities: [ 
      { exclusive: '', effect: 'hmr_rs', value: 25, maxValue: 25},
      { exclusive: '', effect: 'mr_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'wtr_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 3,
    id: 400277,
    abilities: [ 
      { exclusive: '', effect: 'slyr_str', value: 6, maxValue: 6},
      { exclusive: '', effect: 'hl_dbb', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 3,
    id: 400280,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 13, maxValue: 20},
      { exclusive: '', effect: 'skl_prp', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400153,
    abilities: [ 
      { exclusive: '', effect: 'bg_rs', value: 60, maxValue: 100},
      { exclusive: 'wind', effect: 'bg_rs', value: 40, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400083,
    abilities: [ 
      { exclusive: 'shadow', effect: 'afl_grd', value: 'Ⅲ', maxValue: '3'},
      { exclusive: 'shadow', effect: 'prl_rs', value: 75, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400168,
    abilities: [ 
      { exclusive: '', effect: 'h70_dfn', value: 13, maxValue: 20},
      { exclusive: '', effect: 'hp', value: 8, maxValue: 8}
    ]
  }, {
    type: 0,
    id: 400096,
    abilities: [ 
      { exclusive: '', effect: 'drg_dmg', value: 18, maxValue: 18},
      { exclusive: '', effect: 'shs_prp', value: 10, maxValue: 10}
    ]
  }, {
    type: 0,
    id: 400334,
    abilities: [ 
      { exclusive: 'water', effect: 'afl_grd', value: 'Ⅲ', maxValue: '3'},
      { exclusive: 'water', effect: 'skl_hst', value: 9, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400243,
    abilities: [ 
      { exclusive: '', effect: 'frc_chr', value: 'Ⅲ', maxValue: 'Ⅲ'},
      { exclusive: '', effect: 'frc_stk', value: 40, maxValue: 50}
    ]
  }, {
    type: 2,
    id: 400245,
    abilities: [ 
      { exclusive: '', effect: 'hl_dbb', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 0,
    id: 400158,
    abilities: [ 
      { exclusive: '', effect: 'hjp_rs', value: 25, maxValue: 25},
      { exclusive: '', effect: 'jp_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'lgh_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400098,
    abilities: [ 
      { exclusive: 'axe', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'enr_dbb', value: 'Ⅰ', maxValue: 'Ⅰ'}
    ]
  }, {
    type: 0,
    id: 400338,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 15, maxValue: 20},
      { exclusive: '', effect: 'hfl_crt_dmg', value: 22, maxValue: 25}
    ]
  }, {
    type: 2,
    id: 400340,
    abilities: [ 
      { exclusive: '', effect: 'h70_crt_dmg', value: 22, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400097,
    abilities: [ 
      { exclusive: 'dagger', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'flr_str', value: 15, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400380,
    abilities: [ 
      { exclusive: '', effect: 'frc_chr', value: 'Ⅲ', maxValue: 'Ⅲ'},
      { exclusive: '', effect: 'skl_hst', value: 6, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400382,
    abilities: [ 
      { exclusive: '', effect: 'hzd_rs', value: 25, maxValue: 25},
      { exclusive: '', effect: 'zd_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'shd_rs', value: 5, maxValue: 15},
    ]
  }, {
    type: 2,
    id: 400073,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 13, maxValue: 20},
      { exclusive: '', effect: 'unt_hst', value: 'Ⅰ', maxValue: 'Ⅰ'}
    ]
  }, {
    type: 0,
    id: 400384,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 15, maxValue: 20},
      { exclusive: '', effect: 'gg_acl', value: 30, maxValue: 35}
    ]
  }, {
    type: 0,
    id: 400084,
    abilities: [ 
      { exclusive: '', effect: 'drg_dmg', value: 18, maxValue: 18},
      { exclusive: '', effect: 'drg_clw', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 1,
    id: 400135,
    abilities: [ 
      { exclusive: 'wand', effect: 'skl_dmg', value: 40, maxValue: 40},
      { exclusive: '', effect: 'brk_pns', value: 25, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400389,
    abilities: [ 
      { exclusive: '', effect: 'drg_dmg', value: 18, maxValue: 18},
      { exclusive: '', effect: 'drg_tm', value: 15, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400391,
    abilities: [ 
      { exclusive: 'bow', effect: 'crt_rt', value: 14, maxValue: 15},
      { exclusive: '', effect: 'rsl_ofn', value: 10, maxValue: 10}
    ]
  }, {
    type: 4,
    id: 400411,
    abilities: [ 
      { exclusive: '', effect: 'exp_3', value: 10, maxValue: 10}
    ]
  }, {
    type: 3,
    id: 400397,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'frc_stk', value: 40, maxValue: 50}
    ]
  }, {
    type: 3,
    id: 400398,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 13, maxValue: 20},
      { exclusive: '', effect: 'gg_acl', value: 30, maxValue: 35}
    ]
  }, {
    type: 3,
    id: 400399,
    abilities: [ 
      { exclusive: '', effect: 'flr_str', value: 20, maxValue: 20},
      { exclusive: '', effect: 'lgh_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 3,
    id: 400400,
    abilities: [ 
      { exclusive: '', effect: 'h70_crt_dmg', value: 22, maxValue: 25},
      { exclusive: '', effect: 'stkr_str', value: 6, maxValue: 6}
    ]
  }, {
    type: 3,
    id: 400401,
    abilities: [ 
      { exclusive: '', effect: 'skl_hst', value: 8, maxValue: 15},
      { exclusive: '', effect: 'stk_hst', value: 12, maxValue: 15}
    ]
  }, {
    type: 3,
    id: 400412,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 13, maxValue: 20},
      { exclusive: '', effect: 'lst_rcv', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 0,
    id: 400395,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 20, maxValue: 25},
      { exclusive: 'shadow', effect: 'flr_dvs', value: 12, maxValue: 15}
    ]
  }, {
    type: 1,
    id: 400393,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 15, maxValue: 20},
      { exclusive: '', effect: 'prl_pns', value: 20, maxValue: 25}
    ]
  }, {
    type: 1,
    id: 400407,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 30, maxValue: 40},
      { exclusive: '', effect: 'h70_crt_dmg', value: 17, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400409,
    abilities: [ 
      { exclusive: 'wind', effect: 'skl_hst', value: 10, maxValue: 15},
      { exclusive: 'wind', effect: 'bf_tm', value: 25, maxValue: 30}
    ]
  }, {
    type: 2,
    id: 400431,
    abilities: [ 
      { exclusive: 'wind', effect: 'enr_dbb', value: 'Ⅰ', maxValue: 'Ⅰ'}
    ]
  }, {
    type: 3,
    id: 400416,
    abilities: [ 
      { exclusive: 'shadow', effect: 'afl_grd', value: 'Ⅲ', maxValue: 'Ⅲ'},
      { exclusive: '', effect: 'shs_prp', value: 10, maxValue: 10}
    ]
  }, {
    type: 3,
    id: 400417,
    abilities: [ 
      { exclusive: '', effect: 'h70_crt_rt', value: 10, maxValue: 15},
      { exclusive: '', effect: 'crt_dmg_dbb', value: 15, maxValue: 25}
    ]
  }, {
    type: 3,
    id: 400424,
    abilities: [ 
      { exclusive: '', effect: 'flr_str', value: 20, maxValue: 20},
      { exclusive: '', effect: 'flr_dvs', value: 10, maxValue: 15}
    ]
  }, {
    type: 3,
    id: 400418,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 50, maxValue: 50},
      { exclusive: '', effect: 'brk_pns', value: 25, maxValue: 30}
    ]
  }, {
    type: 3,
    id: 400419,
    abilities: [ 
      { exclusive: '', effect: 'lst_ofn', value: 50, maxValue: 60},
      { exclusive: '', effect: 'lst_crt_rt', value: 30, maxValue: 40}
    ]
  }, {
    type: 1,
    id: 400413,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 15, maxValue: 20},
      { exclusive: '', effect: 'psn_pns', value: 20, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400285,
    abilities: [ 
      { exclusive: '', effect: 'flr_str', value: 20, maxValue: 20},
      { exclusive: '', effect: 'h70_crt_rt', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400288,
    abilities: [ 
      { exclusive: '', effect: 'hfl_skl_dmg', value: 40, maxValue: 40}
    ]
  }
].reverse()
